import { createProgrammaticDisable } from '../createProgrammaticDisable';

export const DISABLE_ON_E2E_KEY = 'e2eTesting';

const useDisableOnE2E = createProgrammaticDisable(DISABLE_ON_E2E_KEY);

export default useDisableOnE2E;
